<div>
  <app-round-of-questions-filter
    (search)="searchRoundOfQuestions($event)">
  </app-round-of-questions-filter>
  <mat-divider></mat-divider>
  <app-round-of-questions-table *ngIf="roundOfQuestions"
    [roundOfQuestions]="roundOfQuestions.content"
    [pageSize]="roundOfQuestions.size"
    [totalElements]="roundOfQuestions.totalElements"
    (loadRoundOfQuestions)="loadRoundOfQuestions($event)"
    (updateRoundOfQuestionsStatus)="updateRoundOfQuestionsStatus($event)">
  </app-round-of-questions-table>
</div>
